export const waitPromise = async <T>(promise: Promise<T>, set: (loading: boolean) => unknown) => {
    set(true);

    try {
        return await promise;
    } finally {
        set(false);
    }
};
